module.exports = __webpack_public_path__ + "static/media/new_flight_meta_PE_cover.c08dcb6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new_flight_meta_PE_cover.png
// module id = 1440
// module chunks = 0